// ServiceSection.jsx

import React from "react";
import servicesList from "../data/servicesList";  // Path to your new file

const ServiceSection = ({ title, path, whatsappnumber }) => {
  // Get the service items for the given path, or an empty array if none
  const serviceItems = servicesList[path] || [];

  return (
    <section className="prt-row service-section01 clearfix">
      <div className="container">
        <div className="row">
          {/* Left column (heading, CTA, etc.) */}
          <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 prt-sticky-column">
            <div>
              <div className="tm-scrollintetx-wrapper Frists mt_20 res-991-mt-0">
                <div className="big-title">{title}</div>
              </div>
              <div className="section-title mt-5 res-991-mb-0">
                <div className="title-header">
                  <h2 className="title">
                    Citas disponibles en{" "}
                    <span className="title-heading-underline">WhatsApp</span>
                  </h2>
                </div>
              </div>
              <div className="mt-35 res-991-mt-10">
                <a
                  target="_blank" rel="noreferrer noopener" className="imagebox-heading-service-link prt-btn prt-btn-size-md prt-btn-shape-square prt-btn-style-fill prt-btn-color-skin"
                  href={"https://wa.me/" + whatsappnumber}
                >
                  ¡Pide tu cita ya!
                </a>
              </div>
            </div>
          </div>

          {/* Right column (maps over serviceItems) */}
          <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
            <div className="ml_30 res-991-ml-0 res-1199-mt-30">
              {serviceItems.map((service) => (
                <div
                  className="imagebox-service style3"
                  key={service.id}
                >
                  <div className="imagebox-thumbnail-service">
                    {/* <img
                      width="136"
                      height="120"
                      src={service.imageUrl}
                      loading="lazy"
                      alt={service.title}
                    /> */}
                  </div>
                  <div className="imagebox-content-service">
                    <div className="imagebox-title-service">
                      <h3 className="imagebox-heading-service">
                        <a
                          href={service.link}
                          className="imagebox-heading-service-link"
                        >
                          {service.title}
                        </a>
                      </h3>
                    </div>
                    <div className="imagebox-desc-service">
                      <p className="imagebox-text-service">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              {/* Fin del mapeo de servicios */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
